export default __webpack_public_path__ + "static/media/threedot.dc07a3c7.svg";